import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '@/components/shadcn/form'
import { Switch } from '@/components/shadcn/switch'
import { BaseFieldProps } from './types'
import clsx from 'clsx'
import { DocumentationButton } from './DocumentationButton'

export const BooleanField: React.FC<BaseFieldProps> = ({ field, formFieldName, control, variant }) => {
  const isCompact = variant === 'row' || variant === 'inline'

  return (
    <FormField
      control={control}
      name={formFieldName}
      render={({ field: formField }) => (
        <FormItem
          className={clsx(field.widget === 'hidden' && 'hidden', {
            'flex flex-col gap-1': !isCompact,
            'flex items-center': isCompact,
          })}
        >
          <div className="flex items-center gap-2">
            <FormControl>
              <Switch
                checked={formField.value as boolean}
                onCheckedChange={formField.onChange}
                disabled={field.readOnly}
              />
            </FormControl>
            <FormLabel className={clsx('whitespace-nowrap', { hidden: variant === 'inline' })}>{field.title}</FormLabel>
            {!isCompact && <DocumentationButton documentation={field.documentation} />}
          </div>
          {field.description && !isCompact && (
            <FormDescription className="text-xs">{field.description}</FormDescription>
          )}
          {!isCompact && <FormMessage />}
        </FormItem>
      )}
    />
  )
}
